import React from 'react';
import styled from 'styled-components';

function StarRating({ rating = 0, maxStars = 5, size = '16px' }) {
  const stars = [];

  for (let i = 1; i <= maxStars; i++) {
    const isFilled = i <= rating;
    stars.push(
      <Star key={i} $filled={isFilled} $size={size}>
        ★
      </Star>
    );
  }

  return (
    <StarContainer>
      {stars}
      <RatingText>{rating.toFixed(1)}</RatingText>
    </StarContainer>
  );
}

const StarContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 0.125rem;
`;

const Star = styled.span`
  color: ${({ $filled }) => ($filled ? '#FFB400' : '#E0E0E0')};
  font-size: ${({ $size }) => $size};
  line-height: 1;
  transition: color 0.2s ease;
`;

const RatingText = styled.span`
  color: var(--connolly-black);
  font-size: 0.875rem;
  font-weight: 600;
  margin-left: 0.375rem;
`;

export default StarRating;
